import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../SectionHeading';

const WorldLost = () => (
  <section className="py-24 bg-brand-dark border-t border-white/5">
    <div className="max-w-5xl mx-auto px-6 lg:px-8">
      <SectionHeading title="The World That Almost Was Lost" subtitle="Act I" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          <p className="text-gray-300 leading-relaxed text-lg mb-6">
            The story begins not with triumph, but with reckoning. Earth in the mid-21st century is a world in free fall — coral reefs collapsing, the Amazon converting to savanna, <span className="text-white font-medium">2 billion climate refugees</span> on the move, and a civilization incapable of choosing its own survival over its own comfort.
          </p>
          <p className="text-gray-400 leading-relaxed">
            When the <span className="text-brand-accent font-medium">Marburg-X pandemic</span> sweeps the globe between 2067 and 2070, killing 340 million in three years, it doesn't break humanity — it forces it to finally ask the question it had been avoiding: <em className="text-white">what are we willing to become?</em>
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="bg-brand-surface border border-white/5 rounded-2xl p-8"
        >
          <div className="space-y-6">
            {[
              { label: "Climate refugees displaced", value: "2 Billion" },
              { label: "Marburg-X casualties", value: "340 Million" },
              { label: "Peak Earth population (2058)", value: "7.4 Billion" },
              { label: "Earth population by 2501", value: "3 Billion" },
            ].map((stat, i) => (
              <div key={i} className="flex justify-between items-center border-b border-white/5 pb-4 last:border-0 last:pb-0">
                <span className="text-gray-500 text-sm">{stat.label}</span>
                <span className="text-brand-accent font-display font-bold text-xl">{stat.value}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mt-10 bg-brand-surface border-l-4 border-brand-accent rounded-r-xl p-6"
      >
        <p className="text-gray-300 leading-relaxed">
          The answer arrives from a laboratory in Zurich, where <span className="text-white font-semibold">Dr. Elena Vasquez</span> produces the first stable quantum processor — a machine that can do something no machine ever had before. That moment is the spark of the Quantum Awakening, the civilizational inflection point around which all eleven chapters revolve.
        </p>
      </motion.div>
    </div>
  </section>
);

export default WorldLost;